// Mirrors backend/services/renewals.py so the Renew dialog can preview the
// new expiry dates before anything is saved. Dates are "YYYY-MM-DD" strings.

export const RENEW_MONTH_OPTIONS = [1, 3, 6, 12, 24];

// Today's date in the club's time zone, as YYYY-MM-DD.
export function clubToday(timeZone) {
  try {
    return new Intl.DateTimeFormat("en-CA", { timeZone, year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
  } catch (e) {
    return new Intl.DateTimeFormat("en-CA", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
  }
}

export function addMonths(ymd, months) {
  const [y, m, d] = ymd.split("-").map(Number);
  const total = m - 1 + months;
  const year = y + Math.floor(total / 12);
  const month = (total % 12) + 1;
  const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
  const day = Math.min(d, lastDay);
  return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
}

// From the current expiry if still valid, else from today.
export function renewalDate(currentExpiry, today, months) {
  const old = currentExpiry ? String(currentExpiry).slice(0, 10) : null;
  const base = old && /^\d{4}-\d{2}-\d{2}$/.test(old) && old >= today ? old : today;
  return addMonths(base, months);
}

// ---- CSV export -----------------------------------------------------------

const EXPORT_COLUMNS = ["member_name", "member_id", "member_email", "membership_status", "expiry_date", "photo_url"];

function csvCell(value) {
  const s = value == null ? "" : String(value);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

// Same columns as the import template, dates as YYYY-MM-DD, so an export
// can be edited in a spreadsheet and imported straight back.
export function membersToCsv(members) {
  const rows = members.map((m) =>
    EXPORT_COLUMNS.map((c) => csvCell(c === "expiry_date" ? (m.expiry_date ? String(m.expiry_date).slice(0, 10) : "") : m[c]))
  );
  return [EXPORT_COLUMNS, ...rows].map((r) => r.join(",")).join("\r\n");
}
